<header class="main-header">
  <button
    class="btn-icon menu-toggle"
    type="button"
    [attr.aria-label]="sidebarCollapsed ? 'Déplier le menu' : 'Replier le menu'"
    (click)="onMenuToggle()">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="22" height="22">
      <line x1="3" y1="12" x2="21" y2="12"></line>
      <line x1="3" y1="6" x2="21" y2="6"></line>
      <line x1="3" y1="18" x2="21" y2="18"></line>
    </svg>
  </button>
  <div class="header-actions">
    <div class="zone-badge" *ngIf="estZoneVisible()">
      <span class="zone-badge__icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
          <circle cx="12" cy="10" r="3"></circle>
        </svg>
      </span>
      <span class="zone-badge__label">{{ libelleRoleZone() }}</span>
      <span class="zone-badge__nom">{{ zoneNom }}</span>
    </div>
    <div class="dropdown" [class.active]="notificationsDropdownOpen" id="notificationsDropdown">
      <button class="btn-icon notif-bell-btn" [class.has-unread]="hasUnread()" type="button" (click)="toggleNotifications()" aria-label="Notifications">
        <i class="fal fa-bell" style="font-size:18px;"></i>
        <span class="notif-badge" *ngIf="hasUnread()">{{ nbNonLues }}</span>
      </button>
      <div class="dropdown-menu dropdown-menu--notif">
        <div class="notif-dropdown-header">
          <span class="notif-dropdown-title">Notifications</span>
          <button type="button" class="notif-mark-all" *ngIf="hasUnread()" (click)="marquerToutLu()">
            Tout marquer lu
          </button>
        </div>

        <!-- Liste des 5 dernières -->
        <div class="notif-list" *ngIf="notificationsRecentes.length > 0">
          <div class="notif-item"
               *ngFor="let n of notificationsRecentes"
               [class.notif-item--unread]="!n.lu"
               (click)="marquerNotificationLue(n.id)">
            <div class="notif-item-icon" [ngClass]="couleurType(n.type)">
              <i [class]="iconeClass(n.type)"></i>
            </div>
            <div class="notif-item-body">
              <div class="notif-item-title">{{ n.titre }}</div>
              <div class="notif-item-text">{{ n.message }}</div>
              <div class="notif-item-time">{{ formatTempsDropdown(n.dateCreation) }}</div>
            </div>
            <span class="notif-dot" *ngIf="!n.lu"></span>
          </div>
        </div>

        <!-- Vide -->
        <div class="notif-empty" *ngIf="notificationsRecentes.length === 0">
          <i class="fal fa-bell-slash"></i>
          <span>Aucune notification</span>
        </div>

        <div class="notif-footer">
          <a routerLink="/notifications" (click)="closeNotifications()">
            Voir toutes les notifications
            <i class="fal fa-arrow-right" style="font-size:11px;"></i>
          </a>
        </div>
      </div>
    </div>

    <div class="dropdown" [class.active]="profileDropdownOpen" id="profileDropdown">
      <button class="btn-icon" type="button" (click)="toggleProfile()" aria-label="Menu utilisateur">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
      </button>
      <div class="dropdown-menu dropdown-menu-profile">
        <div class="profile-header">
          <div class="profile-avatar">{{ userInitials }}</div>
          <div class="profile-info">
            <div class="profile-name">{{ userName }}</div>
            <div class="profile-email">{{ userEmail }}</div>
          </div>
        </div>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item" routerLink="/parametres" (click)="closeProfileDropdown()">
          <span class="dropdown-item-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
              <circle cx="12" cy="12" r="3"></circle>
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
            </svg>
          </span>
          <span class="dropdown-item-text">Paramètres</span>
        </a>
        <div class="dropdown-divider"></div>
        <button type="button" class="dropdown-item dropdown-item-btn" (click)="logout()">
          <span class="dropdown-item-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
          </span>
          <span class="dropdown-item-text">Déconnexion</span>
        </button>
      </div>
    </div>
  </div>
</header>